
import React, { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { useUrlFriendlyToParameters, useNavigateTo } from 'helpers/urlFriendly';
import { getMedal } from "data/Querys";
import MirsTable from 'components/general/table/Table.js';
import Label from 'components/general/Label';
import Loader from "components/general/Loader";
import NotAvailable from "components/common/NotAvailable";
import { ColumnOrganisation, ColumnNoc } from "components/common/TableColumns"
import PageHeader from 'components/common/PageHeader';
import { Stack } from 'react-bootstrap';
import SelectorDiscipline from 'components/common/selectors/selector-discipline/selectorDiscipline';
import SelectorNoc from 'components/common/selectors/selector-noc';
import { ALL_URL } from "helpers/utils";
import SelectorGender from 'components/common/selectors/selector-gender';
import Medal from 'components/presentation/Medal';


export default function MultiMedallists() {
    const { mirs_competition, mirs_language, mirs_discipline, mirs_gender, mirs_noc } = useUrlFriendlyToParameters()
    const params = useUrlFriendlyToParameters()
    const [paramsUrl, setParamsUrl] = useState({});
    const [shouldNavigate, setShouldNavigate] = useState(false);
    useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, "medal")

    /*
    //Get Data
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['medalTable', mirs_competition, mirs_language],
            queryFn: getMedal,
            refetchInterval: 5000,
        });

    if (isError) { return <NotAvailable />; }
    if (isLoading) { return <Loader />; }
    if (!data?.medalNOC) { return <NotAvailable /> }
*/
    return (
        <>
            <PageHeader title={Label({ data: 'MultiMedallists' })} />
            <div>To do </div>
        </>
    )
};

